var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIssueCount = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.5C2.72386 2.5 2.5 2.72386 2.5 3C2.5 3.27614 2.72386 3.5 3 3.5C3.27614 3.5 3.5 3.27614 3.5 3C3.5 2.72386 3.27614 2.5 3 2.5ZM1.5 3C1.5 2.17158 2.17158 1.5 3 1.5C3.82842 1.5 4.5 2.17158 4.5 3C4.5 3.65311 4.08259 4.20873 3.5 4.41465V4.5C3.5 5.0523 3.94771 5.5 4.5 5.5H7.5C8.0523 5.5 8.5 5.0523 8.5 4.5V4.41465C7.9174 4.20873 7.5 3.65311 7.5 3C7.5 2.17158 8.17155 1.5 9 1.5C9.82845 1.5 10.5 2.17158 10.5 3C10.5 3.65311 10.0826 4.20873 9.5 4.41465V4.5C9.5 5.60455 8.60455 6.5 7.5 6.5H6.5V7.58535C7.0826 7.79125 7.5 8.3469 7.5 9C7.5 9.82845 6.82845 10.5 6 10.5C5.17155 10.5 4.5 9.82845 4.5 9C4.5 8.3469 4.91741 7.79125 5.5 7.58535V6.5H4.5C3.39543 6.5 2.5 5.60455 2.5 4.5V4.41465C1.91741 4.20873 1.5 3.65311 1.5 3ZM9 2.5C8.72385 2.5 8.5 2.72386 8.5 3C8.5 3.27614 8.72385 3.5 9 3.5C9.27615 3.5 9.5 3.27614 9.5 3C9.5 2.72386 9.27615 2.5 9 2.5ZM6 8.5C5.72385 8.5 5.5 8.72385 5.5 9C5.5 9.27615 5.72385 9.5 6 9.5C6.27615 9.5 6.5 9.27615 6.5 9C6.5 8.72385 6.27615 8.5 6 8.5Z",
    fill: "#D92D20"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIssueCount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IssueCount.09e79b67.svg";
export { ForwardRef as ReactComponent };